var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('base-section-heading',{attrs:{"title":"Aderisci al progetto","space":0}}),_c('div',{ref:"contactForm"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }